import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { showStoreLocatorModal, completeStoreSelection } from 'actions/storeLocator'
import StoreAddressInput from './StoreAddressInput'

const withSelectionHandlers = withHandlers({
  handleStoreSelected: ({ completeStoreSelection, input }) => ({ storeNumber, addressObject }) => {
    const {
      zipcode,
      city,
      address1,
      state
    } = addressObject

    input.onChange(`${storeNumber}, ${address1}, ${city}, ${state}, ${zipcode}`)

    return completeStoreSelection()
  }
})

const withModalHandlers = withHandlers({
  handleModalOpen: ({ showStoreLocatorModal, handleStoreSelected }) =>
    () => showStoreLocatorModal({ handleSelectStore: handleStoreSelected })
})

export default compose(
  connect(null, { showStoreLocatorModal, completeStoreSelection }),
  withSelectionHandlers,
  withModalHandlers
)(StoreAddressInput)
